import { isIE } from '../../util';
import { exportActions, service } from '..';
import moment from 'moment';

const endpoint = 'cart';
const customExportEndpoint = 'export';

const downloadFile = ( type, response, fileName ) => {
  const blob = new Blob( [response.data] );
  const timeStamp = moment( new Date() ).format( 'YYYY-MM-DD_HH-mm-ss' );
  fileName = fileName || `CartExport_${timeStamp}.${type.toLowerCase()}`;

  if ( isIE() ) {
    window.navigator.msSaveOrOpenBlob( blob, fileName );
  } else {
    const link = document.createElement( 'a' );
    const url = window.URL.createObjectURL( blob );
    link.href = url;
    link.download = fileName;
    document.body.appendChild( link );
    link.click();
    setTimeout( () => {
      document.body.removeChild( link );
      window.URL.revokeObjectURL( url );
    }, 100 );
  }
};

export const exportService = {
  get: () => service( endpoint ).get( ['export', 'info'] ).then( result => ( { data: result.data, type: exportActions.LOAD } ) ),
  downloadExport: action => {
    const data = {
      fileType: action.exportType,
      exporterName: 'generic',
      data: action.data
    };

    return service( endpoint )
      .post( data, ['export', 'generic'], { responseType: 'arraybuffer' } )
      .then( response => downloadFile( action.exportType, response ) );
  },
  customExport: action => {
    const data = {
      fileType: action.exportType,
      exporterName: 'generic',
      customTemplateFileName: action.template,
      data: action.data,
      metaData: action.metaData
    };

    return service( customExportEndpoint )
      .post( data, '', { responseType: 'arraybuffer' } )
      .then( response => downloadFile( action.exportType, response, action.fileName ) );
  }
};